function looksLikeEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

/**
 * Resolve a display label from a user profile document or User model instance.
 */
export function resolveProfileDisplayName(user) {
  if (!user) return '';

  const display = String(user.displayName || '').trim();
  if (display && !looksLikeEmail(display)) return display;

  const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
  if (fullName) return fullName;

  return '';
}

/**
 * Resolve a display label from a stored message payload.
 */
export function resolveMessageAuthorName(message) {
  if (!message) return '';

  const display = String(message.displayName || '').trim();
  if (display && !looksLikeEmail(display)) return display;

  const firstName = String(message.firstName || '').trim();
  const lastName = String(message.lastName || '').trim();
  const fullName = `${firstName} ${lastName}`.trim();
  if (fullName) return fullName;

  return '';
}

/** Presentational label — normalizes legacy ALL CAPS names for the UI. */
export function formatAuthorLabel(name) {
  return String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

